// Setter funnel stage machine, loss-reason catalogue and per-project qualification (spec §05.1, §08.9, §04).
// Schemas in api-funnel.ts. Shared by every module (module: null).
import * as F from './api-funnel.js';
import { LeadAttributionSchema } from './api-attribution.js';
import { IdParam, items, route, W, Ws } from './route-def.js';

const Lead = W({ interestId: IdParam });

export const funnelRoutes = {
  getLeadFunnel: route({
    method: 'GET', path: '/workspaces/:workspaceId/leads/:interestId/funnel', summary: 'Etapa, historial de etapas y calificación de una oportunidad', tag: 'leads',
    minRole: 'advisor', module: null, params: Lead, response: F.LeadFunnelSchema,
  }),
  getLeadAttribution: route({
    method: 'GET', path: '/workspaces/:workspaceId/leads/:interestId/attribution', summary: 'Origen y puntos de contacto de una oportunidad (primer y último contacto; historial sin sobrescribir)', tag: 'leads',
    minRole: 'advisor', module: null, params: Lead, response: LeadAttributionSchema,
  }),
  setLeadStage: route({
    method: 'POST', path: '/workspaces/:workspaceId/leads/:interestId/stage', summary: 'Cambiar la etapa manualmente (prevalece sobre la automatización; Perdido exige motivo)', tag: 'leads',
    minRole: 'advisor', module: null, params: Lead, body: F.SetLeadStageSchema, response: F.LeadFunnelSchema,
  }),
  setLeadQualificationValue: route({
    method: 'PUT', path: '/workspaces/:workspaceId/leads/:interestId/qualification/:field', summary: 'Registrar o corregir un dato de calificación (conserva el historial)', tag: 'leads',
    minRole: 'advisor', module: null, params: W({ interestId: IdParam, field: F.CriterionKeySchema }), body: F.SetQualificationValueSchema, response: F.LeadFunnelSchema,
  }),
  listLossReasons: route({
    method: 'GET', path: '/workspaces/:workspaceId/loss-reasons', summary: 'Catálogo de motivos de pérdida (base + extensiones del desarrollador/proyecto)', tag: 'leads',
    minRole: 'advisor', module: null, params: Ws, query: F.LossReasonListQuerySchema, response: items(F.LossReasonSchema),
  }),
  createLossReason: route({
    method: 'POST', path: '/workspaces/:workspaceId/loss-reasons', summary: 'Agregar un motivo de pérdida del desarrollador o de un proyecto', tag: 'leads',
    minRole: 'admin', module: null, params: Ws, body: F.CreateLossReasonSchema, response: F.LossReasonSchema, status: 201,
  }),
  updateLossReason: route({
    method: 'PATCH', path: '/workspaces/:workspaceId/loss-reasons/:reasonId', summary: 'Editar o desactivar un motivo de pérdida propio (los base no cambian)', tag: 'leads',
    minRole: 'admin', module: null, params: W({ reasonId: IdParam }), body: F.UpdateLossReasonSchema, response: F.LossReasonSchema,
  }),
  getQualificationConfig: route({
    method: 'GET', path: '/workspaces/:workspaceId/projects/:projectId/qualification', summary: 'Criterios de calificación del proyecto', tag: 'projects',
    minRole: 'advisor', module: null, params: W({ projectId: IdParam }), response: F.QualificationConfigResponseSchema,
  }),
  putQualificationConfig: route({
    method: 'PUT', path: '/workspaces/:workspaceId/projects/:projectId/qualification', summary: 'Guardar criterios de calificación del proyecto', tag: 'projects',
    minRole: 'admin', module: null, params: W({ projectId: IdParam }), body: F.QualificationConfigSchema, response: F.QualificationConfigResponseSchema,
  }),
};
